import { StateV17 } from './17_migrate_elementar_vorschaden_ersatzgeschaeft.interface';

export const migrateElementarVorschadenErsatzgeschaeft = (
  previousState: StateV17,
  newVersion: number,
): StateV17 => {
  return {
    ...previousState,
    vorschaeden: previousState.vorschaeden
      ? {
          ...previousState.vorschaeden,
          elementarVisibleInErsatzgeschaeft:
            previousState.vorschaeden.elementarVisibleInErsatzgeschaeft ?? false,
        }
      : previousState.vorschaeden,
    version: newVersion,
  };
};
